import axios from 'axios';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';

const RegistrarInformeContractual = () => {
  const { id, informeId } = useParams();
  const navigate = useNavigate();

  const [obligaciones, setObligaciones] = useState([]);
  const [acciones, setAcciones] = useState([]);
  const [evidencias, setEvidencias] = useState([]);

  const [mes, setMes] = useState('');
  const [anio, setAnio] = useState(new Date().getFullYear());
  const [activeTab, setActiveTab] = useState('obligaciones');

  const [desplazamientos, setDesplazamientos] = useState([]);

  const [ciudad, setCiudad] = useState('');
  const [fechaInforme, setFechaInforme] = useState('');
  const [numeroPlanilla, setNumeroPlanilla] = useState('');
  const [periodoPlanilla, setPeriodoPlanilla] = useState('');
  const [operadorPlanilla, setOperadorPlanilla] = useState('');

  const [edit, setEdit] = useState(false);

  useEffect(() => {
    setEdit(!!informeId); // true si hay un informeId (modo edición)
  }, [informeId]);

  useEffect(() => {
    const cargarDatosInforme = async () => {
      try {
        if (!informeId) return;

        const res = await axios.get(`/api/informecontractual/listid/${informeId}`);
        const datos = res.data.informe;

        if (datos) {
          setCiudad(datos.ciudad);
          setFechaInforme(datos.fechaInforme?.substring(0, 10));
          setMes(datos.mes);
          setAnio(datos.anio);
          setNumeroPlanilla(datos.numeroPlanilla);
          setPeriodoPlanilla(datos.periodoPlanilla);
          setOperadorPlanilla(datos.operadorPlanilla);
          setDesplazamientos(datos.desplazamientos || []);

          // ✅ Acciones y evidencias
          const acc = datos.obligaciones.map(ob => ob.accion || '');
          const evid = datos.obligaciones.map(ob => ob.evidencia || '');
          setAcciones(acc);
          setEvidencias(evid);

          // ✅ Obtener obligacionid y observacion del populate
          const obs = datos.obligaciones.map(ob => ({
            _id: ob._id, // 👈 esto es clave para conservar el ID embebido
            obligacionid: ob.obligacionid?._id || ob.obligacionid,
            observacion: ob.obligacionid?.observacion || '',
            descripcion: ob.obligacionid?.descripcion || '',
          }));
          setObligaciones(obs);
        }
      } catch (error) {
        console.error('Error al cargar el informe:', error);
      }
    };

    cargarDatosInforme();
  }, [informeId]);




  useEffect(() => {
    const obtenerObligaciones = async () => {
      try {
        if (!id || edit) return; // 🚫 No cargar si es modo edición

        const res = await axios.get(`/api/obligaciones/contrato/${id}`);
        const datos = res.data;

        if (datos.ok) {
          const lista = datos.obligaciones.map((item) => ({
            obligacionid: item._id,
            observacion: item.observacion
          }));

          setObligaciones(lista);
          setAcciones(Array(lista.length).fill(''));
          setEvidencias(Array(lista.length).fill(''));
        } else {
          console.error('Error en la respuesta del servidor:', datos);
        }
      } catch (error) {
        console.error('Error al obtener obligaciones:', error);
      }
    };

    obtenerObligaciones();
  }, [id, edit]); // ✅ agrega `edit` como dependencia


  const cleanData = () => {
    setCiudad('');
    setFechaInforme('');
    setMes('');
    setAnio(new Date().getFullYear());
    setNumeroPlanilla('');
    setPeriodoPlanilla('');
    setOperadorPlanilla('');
    setAcciones([]);
    setEvidencias([]);
    setDesplazamientos([]);
    setObligaciones([]);
    setActiveTab('obligaciones');

  };

  const validarPeriodo = () => {
    if (
      periodoPlanilla === 'DECRETO 1273 DE 2018' &&
      (numeroPlanilla.trim() !== '' || operadorPlanilla.trim() !== '')
    ) {
      Swal.fire({
        icon: 'warning',
        title: 'Validación de Planilla',
        text: 'Si selecciona "DECRETO 1273 DE 2018", los campos "Número de Planilla" y "Operador Planilla" deben estar vacíos.'
      });
      return false;
    }
    return true;
  };


  const saveInforme = async () => {
    try {
      if (!validarPeriodo()) return;

      const informe = obligaciones.map((ob, index) => ({
        obligacionid: ob.obligacionid,
        accion: acciones[index],
        evidencia: evidencias[index]
      }));

      const newInforme = {
        contratoId: id,
        ciudad,
        fechaInforme,
        mes,
        anio,
        numeroPlanilla,
        periodoPlanilla,
        operadorPlanilla,
        obligaciones: informe,
        desplazamientos
      };

      await axios.post('/api/informecontractual/add', newInforme);

      Swal.fire({
        icon: 'success',
        title: 'Informe contractual registrado',
        showConfirmButton: false,
        timer: 1500
      });

      cleanData();

      setTimeout(() => {
        navigate(-1);
      }, 1500);
    } catch (error) {
      console.error('Error al guardar informe:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.response?.data?.message || 'No se pudo guardar el informe.'
      });
    }
  };


  const updateInforme = async () => {
    try {
      if (!validarPeriodo()) return;

      const updatedInforme = {
        contratoId: id,
        ciudad,
        fechaInforme,
        mes,
        anio,
        numeroPlanilla,
        periodoPlanilla,
        operadorPlanilla,
        obligaciones: obligaciones.map((ob, index) => ({
          _id: ob._id,
          obligacionid: ob.obligacionid,
          accion: acciones[index],
          evidencia: evidencias[index]
        })),
        desplazamientos: desplazamientos.map(d => ({
          _id: d._id,
          ordenViajeNo: d.ordenViajeNo || d.orden,
          lugar: d.lugar,
          fechaInicio: d.fechaInicio,
          fechaFinal: d.fechaFinal
        }))
      };

      await axios.put(`/api/informecontractual/update/${informeId}`, updatedInforme);

      Swal.fire({
        icon: 'success',
        title: 'Informe actualizado correctamente',
        showConfirmButton: false,
        timer: 1500
      });

      setTimeout(() => {
        navigate(-1);
      }, 1500);
    } catch (error) {
      console.error('Error al actualizar el informe:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.response?.data?.message || 'No se pudo actualizar el informe.'
      });
    }
  };



  const actions = async (e) => {
    e.preventDefault();
    edit ? updateInforme() : saveInforme();
  };


  const handleAccionChange = (index, value) => {
    const nuevasAcciones = [...acciones];
    nuevasAcciones[index] = value;
    setAcciones(nuevasAcciones);
  };

  const handleEvidenciaChange = (index, value) => {
    const nuevasEvidencias = [...evidencias];
    nuevasEvidencias[index] = value;
    setEvidencias(nuevasEvidencias);
  };

  const handleDesplazamientoChange = (index, field, value) => {
    const nuevos = [...desplazamientos];
    nuevos[index][field] = value;
    setDesplazamientos(nuevos);
  };


  //-----------------------------------------------------------------------

  const agregarFilaDesplazamiento = () => {
    setDesplazamientos([
      ...desplazamientos,
      { orden: '', lugar: '', fechaInicio: '', fechaFin: '' }
    ]);
  };

  const eliminarFilaDesplazamiento = (index) => {
    setDesplazamientos((prev) => prev.filter((_, i) => i !== index));
  };

  //-----------------------------------------------------------------------

  useEffect(() => {
    if (periodoPlanilla === 'DECRETO 1273 DE 2018') {
      setNumeroPlanilla('');
      setOperadorPlanilla('');
    }
  }, [periodoPlanilla]);





  return (
    <div className="container py-5 px-4 bg-light shadow-lg rounded-4 my-5">
      <h2 className="mb-4 text-center">Registrar Informe Contractual Mensual</h2>

      <form onSubmit={actions}>
        {/* Lugar y fecha del informe */}
        <div className="row mb-4">

          <div className="col-md-3">
            <label className="form-label">Ciudad</label>
            <input
              type="text"
              className="form-control"
              placeholder="Ej: Medellín"
              value={ciudad}
              onChange={(e) => setCiudad(e.target.value)}
              required
            />
          </div>

          <div className="col-md-3">
            <label className="form-label">Fecha del Informe</label>
            <input
              type="date"
              className="form-control"
              value={fechaInforme}
              onChange={(e) => setFechaInforme(e.target.value)}
              required
            />
          </div>

          <div className="col-md-3">
            <label className="form-label">Mes</label>
            <select
              className="form-control"
              value={mes}
              onChange={(e) => setMes(e.target.value)}
              required
            >
              <option value="">Seleccione un mes</option>
              {[
                'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
                'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'

              ].map((nombre, idx) => (
                <option key={idx} value={nombre}>{nombre}</option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <label className="form-label">Año</label>
            <input
              type="number"
              className="form-control"
              value={anio}
              onChange={(e) => setAnio(e.target.value)}
              min="2000"
              max="2100"
              required
            />
          </div>

        </div>

        {/* Planilla y periodo */}
        <div className="row mb-4">

          <div className="col-md-3">
            <label className="form-label">Núm Planilla</label>
            <input
              type="text"
              className="form-control"
              placeholder="Ej: 123456789"
              value={numeroPlanilla}
              onChange={(e) => setNumeroPlanilla(e.target.value)}
              required={periodoPlanilla !== 'DECRETO 1273 DE 2018'}
            />
          </div>


          <div className="col-md-3">
            <label className="form-label">Periodo Planilla</label>
            <select
              className="form-select"
              value={periodoPlanilla}
              onChange={(e) => setPeriodoPlanilla(e.target.value)}
              required
            >
              <option value="">Seleccione un periodo</option>
              <option value="DECRETO 1273 DE 2018">DECRETO 1273 DE 2018</option>
              <option value="enero">enero</option>
              <option value="febrero">febrero</option>
              <option value="marzo">marzo</option>
              <option value="abril">abril</option>
              <option value="mayo">mayo</option>
              <option value="junio">junio</option>
              <option value="julio">julio</option>
              <option value="agosto">agosto</option>
              <option value="septiembre">septiembre</option>
              <option value="octubre">octubre</option>
              <option value="noviembre">noviembre</option>
              <option value="diciembre">diciembre</option>


            </select>
          </div>


          <div className="col-md-6">
            <label className="form-label">Operador Planilla</label>
            <select
              className="form-select"
              value={operadorPlanilla}
              onChange={(e) => setOperadorPlanilla(e.target.value)}
              required={periodoPlanilla !== 'DECRETO 1273 DE 2018'}
            >
              <option value="">Seleccione un operador</option>
              <option value="Aportes en Línea">Aportes en Línea</option>
              <option value="Mi Planilla">Mi Planilla</option>
              <option value="SOI">SOI (Servicios Operativos de Información)</option>
              <option value="ARUS">ARUS</option>
              <option value="Compensar PILA">Compensar PILA</option>
              <option value="Enlace Operativo">Enlace Operativo</option>
              <option value="Asopagos">Asopagos</option>
              <option value="Pago Simple">Pago Simple</option>
              <option value="Simple S.A.S">Simple S.A.S</option>
              <option value="Porvenir">Porvenir</option>
              <option value="Bancolombia">Bancolombia</option>
              <option value="Banco de Bogotá">Banco de Bogotá</option>
              <option value="Banco de Occidente">Banco de Occidente</option>
              <option value="Banco Davivienda">Banco Davivienda</option>
              <option value="Banco Popular">Banco Popular</option>
              <option value="Banco AV Villas">Banco AV Villas</option>
              <option value="Banco Caja Social">Banco Caja Social</option>
              <option value="Banco Itaú">Banco Itaú</option>
              <option value="Banco BBVA">Banco BBVA</option>
              <option value="Banco Agrario de Colombia">Banco Agrario de Colombia</option>
              <option value="Scotiabank Colpatria">Scotiabank Colpatria</option>
            </select>
          </div>

        </div>

        {/* Navegación por pestañas */}
        <ul className="nav nav-tabs mb-4">

          <li className="nav-item">
            <button
              type="button"
              className={`nav-link ${activeTab === 'obligaciones' ? 'active' : ''}`}
              onClick={() => setActiveTab('obligaciones')}
            >
              Obligaciones Específicas
            </button>
          </li>

          <li className="nav-item">
            <button
              type="button"
              className={`nav-link ${activeTab === 'desplazamientos' ? 'active' : ''}`}
              onClick={() => setActiveTab('desplazamientos')}
            >
              Registro de Desplazamientos
            </button>
          </li>

        </ul>

        {/* Tabla de obligaciones */}
        {activeTab === 'obligaciones' && (
          <div className="container-fluid px-2">

            {/* Encabezados */}
            <div className="row fw-bold text-center mb-2">
              <div className="col-md-1">#</div>
              <div className="col-md-3">Obligación</div>
              <div className="col-md-4">Acciones Realizadas</div>
              <div className="col-md-4">Evidencias</div>
            </div>

            {/* Filas de contenido */}
            {obligaciones.map((ob, index) => (
              <div key={index} className="row align-items-start mb-3 border rounded shadow-sm p-3 bg-white">
                <div className="col-md-1 text-center pt-2 fw-bold">
                  {index + 1}
                </div>

                <div className="col-md-3">
                  <div className="form-control bg-light">{ob.observacion}</div> {/* ✅ Aquí */}
                </div>

                <div className="col-md-4">
                  <textarea
                    className="form-control"
                    rows="3"
                    value={acciones[index] || ''}
                    onChange={(e) => handleAccionChange(index, e.target.value)}
                    placeholder="Describa las acciones realizadas"
                    required
                  />
                </div>

                <div className="col-md-4">
                  <textarea
                    className="form-control"
                    rows="3"
                    value={evidencias[index] || ''}
                    onChange={(e) => handleEvidenciaChange(index, e.target.value)}
                    placeholder="Describa las evidencias"
                    required
                  />
                </div>
              </div>
            ))}


          </div>
        )}


        {/* Tabla de desplazamientos */}
        {activeTab === 'desplazamientos' && (
          <div className="container-fluid py-3 px-4 shadow-sm rounded bg-white mt-4">

            {/* Encabezado */}
            <div className="row fw-bold text-center mb-2">
              <div className="col-md-3">Orden de Viaje</div>
              <div className="col-md-4">Lugar de Desplazamiento</div>
              <div className="col-md-2">Fecha Inicial</div>
              <div className="col-md-2">Fecha Final</div>
              <div className="col-md-2"></div>
            </div>

            {/* Filas de desplazamientos */}
            {desplazamientos.map((item, index) => (
              <div key={index} className="row align-items-center mb-2">

                <div className="col-md-3">
                  <input
                    type="text"
                    className="form-control text-center"
                    placeholder="Orden de Viaje"
                    value={item.ordenViajeNo || ''}
                    onChange={(e) => handleDesplazamientoChange(index, 'ordenViajeNo', e.target.value)}
                  />
                </div>

                <div className="col-md-4">
                  <input
                    type="text"
                    className="form-control text-center"
                    placeholder="Lugar"
                    value={item.lugar || ''}
                    onChange={(e) => handleDesplazamientoChange(index, 'lugar', e.target.value)}
                  />
                </div>

                <div className="col-md-2">
                  <input
                    type="date"
                    className="form-control text-center"
                    value={item.fechaInicio ? item.fechaInicio.substring(0, 10) : ''}
                    onChange={(e) => handleDesplazamientoChange(index, 'fechaInicio', e.target.value)}
                  />
                </div>

                <div className="col-md-2">
                  <input
                    type="date"
                    className="form-control text-center"
                    value={item.fechaFinal ? item.fechaFinal.substring(0, 10) : ''}
                    onChange={(e) => handleDesplazamientoChange(index, 'fechaFinal', e.target.value)}
                  />
                </div>

                <div className="col-md-1">
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={() => eliminarFilaDesplazamiento(index)}
                  >
                    <i className="fas fa-trash"></i>
                  </button>
                </div>

              </div>
            ))}


            {/* Botón para agregar nueva fila */}
            <div className='container'>
              <div className="row container-flex mt-3 mb-3">
                <div className="col d-flex justify-content-center">
                  <button
                    type="button"
                    className="btn btn-primary w-100 d-flex  justify-content-center"
                    onClick={agregarFilaDesplazamiento}
                  >
                    Agregar Fila
                  </button>
                </div>
              </div>
            </div>

          </div>
        )}


        {/* Botón de guardar */}
        <div className='container'>
          <div className="row container-flex mt-4">
            <div className="col d-flex justify-content-center gap-2">
              <button
                type="submit"
                className="btn btn-success w-50 d-flex justify-content-center"
              >
                {edit ? 'Actualizar Informe' : 'Guardar Informe'}
              </button>

              <button
                type="button"
                className="btn btn-danger w-50 d-flex justify-content-center"
                onClick={() => navigate(-1)}
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>

      </form>
    </div>
  );
};

export default RegistrarInformeContractual;
